import dayjs from 'dayjs';

/**
 * Formate une date dans un format spécifique (par défaut DD/MM/YYYY)
 *
 * @param {string} [date] La date à formater
 * @param {string} [format=DD/MM/YYYY] Le format
 * @returns {string} La date formatée
 */
export function formatDate(date: string | undefined, format = 'DD/MM/YYYY'): string {
  if (date === undefined) {
    return '';
  }

  // Détermine le format de la date
  let inputFormat = '';

  if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
    inputFormat = 'YYYY-MM-DD';
  } else if (date.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    inputFormat = 'DD/MM/YYYY';
  } else {
    inputFormat = 'YYYY-MM-DD';
  }

  return dayjs(date, inputFormat).format(format);
}

/**
 * Formate une date au format DD/MM/YYYY HH:mm
 *
 * @param {string} [date] The date to format
 * @returns {string} The formatted date
 */
export function formatDateTime(date: string | undefined): string {
  return formatDate(date, 'DD/MM/YYYY HH:mm');
}

/**
 * TODO Fix saisie date - à améliorer
 */
export function isValidDate(date: string | null): boolean {
  if (date === null || date === undefined) {
    return false;
  }
  return dayjs(date).isValid() && dayjs(date).year() >= 2000;
}
